// extracted by mini-css-extract-plugin
module.exports = {"tabsContainer":"style_tabsContainer__2pzKj","buttonContainer":"style_buttonContainer__3UqJq","selected":"style_selected__sJPyU","tabsContent":"style_tabsContent__TS6WE"};